"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mayStoreLongTaskIdForProfilerCorrelation = mayStoreLongTaskIdForProfilerCorrelation;
const browser_rum_core_1 = require("@datadog/browser-rum-core");
const longTaskRegistry_1 = require("./utils/longTaskRegistry");
/**
 * Store the Long Task ID in the registry for the Profiler to link it with the corresponding Profile.
 *
 * @param options - The options for the function
 * @param options.rawRumEvent - The Raw RUM event
 * @param options.startTime - The start time of the event (in this case the Long Task Performance Entry start time)
 */
function mayStoreLongTaskIdForProfilerCorrelation({ rawRumEvent, startTime, }) {
    if (rawRumEvent.type !== browser_rum_core_1.RumEventType.LONG_TASK) {
        return;
    }
    const longTaskId = rawRumEvent.long_task.id;
    // Store longTaskId in the registry for the Profiler to link it with the corresponding Profile.
    (0, longTaskRegistry_1.setLongTaskId)(longTaskId, startTime);
}
//# sourceMappingURL=profilingCorrelation.js.map